import {
    CLEAN_RESIDENT,
    RESIDENT,
    RESIDENT_SUCCESS,
    RESIDENT_ERROR,
    ADD_RESIDENT,
    ADD_RESIDENT_SUCCESS,
    ADD_RESIDENT_ERROR,
    UPDATE_RESIDENT,
    UPDATE_RESIDENT_SUCCESS,
    UPDATE_RESIDENT_ERROR,
    DELETE_RESIDENT,
    DELETE_RESIDENT_SUCCESS,
    DELETE_RESIDENT_ERROR,
    GET_TAGS_RESIDENT,
    GET_TAGS_RESIDENT_ERROR,
    GET_TAGS_RESIDENT_SUCCESS,
    RESIDENT_BY_TAGS,
    RESIDENT_BY_TAGS_ERROR,
    RESIDENT_BY_TAGS_SUCCESS,
    SYNC_RESIDENTS,
    SYNC_RESIDENTS_SUCCESS,
    SYNC_RESIDENTS_ERROR,
    SYNC_RESIDENTS_BY_COMMUNITY,
    SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS,
    SYNC_RESIDENTS_BY_COMMUNITY_ERROR
} from "../constants/residentConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function residentReducer(state = initialState, action) {
    switch (action.type) {
        case CLEAN_RESIDENT:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': '',
                'residentData': [],
                'type': action.type
            });
        case RESIDENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENTS ARE BEING LOADED',
                'type': action.type
            });
        case RESIDENT_SUCCESS:
            const currentdataCommunityId = (state.residentData && state.residentData.length > 0) ? state.residentData[0].communityId : undefined;
            const newDataCommunityId = (action.data && action.data.length > 0) ? action.data[0].communityId : undefined;

            let data = state.residentData;

            if (action.data && action.data.length > 0) {
                if (currentdataCommunityId !== newDataCommunityId) {
                    data = action.data
                } else {
                    //filter new Data
                    const residentDataIds = state.residentData.map(r => r._id)
                    const newData = action.data.filter(d => !residentDataIds.includes(d._id))
                    data = state.residentData.concat(newData);
                }
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentData': data,
                'type': action.type
            });
        case RESIDENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_RESIDENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENT IS BEING SAVED',
                'type': action.type
            });
        case ADD_RESIDENT_SUCCESS:
            const oldresidentData = state.residentData ? state.residentData : []
            let newResidentData = [...oldresidentData, action.data];

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentData': newResidentData,
                'type': action.type
            });
        case ADD_RESIDENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_RESIDENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENT IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_RESIDENT_SUCCESS:
            const residentData = state.residentData ? state.residentData : []
            let updatedResidentData = residentData.map(item => item._id === action.data._id ? action.data : item);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentData': updatedResidentData,
                'type': action.type
            });
        case UPDATE_RESIDENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_RESIDENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENT IS BEING DELETED',
                'type': action.type
            });
        case DELETE_RESIDENT_SUCCESS:
            const resData = state.residentData ? state.residentData : []
            let newResData = resData.filter(item => item._id !== action.data);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentData': newResData,
                'type': action.type
            });
        case DELETE_RESIDENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_TAGS_RESIDENT:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_TAGS_RESIDENT_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'tags': action.data,
                'type': action.type
            });
        case GET_TAGS_RESIDENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case RESIDENT_BY_TAGS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENTS ARE BEING LOADED',
                'type': action.type
            });
        case RESIDENT_BY_TAGS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentDataSTBVersion': action.data.length > 0 ? action.data : undefined,
                'type': action.type
            });
        case RESIDENT_BY_TAGS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case SYNC_RESIDENTS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENTS ARE BEING SYNC FROM CL',
                'type': action.type
            });
        case SYNC_RESIDENTS_SUCCESS:
            const oldresData = state.residentData ? state.residentData : []

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentData': oldresData,
                'type': action.type
            });
        case SYNC_RESIDENTS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case SYNC_RESIDENTS_BY_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'RESIDENT',
                'loadingMessage': 'THE RESIDENTS ARE BEING SYNC FROM CL',
                'type': action.type
            });
        case SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residentData': [],
                'type': action.type
            });
        case SYNC_RESIDENTS_BY_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        default:
            return state;
    }
};

export default residentReducer;